module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.2dbbf59c.woff2";